import { IconMissing } from '../../../../../../../components/icons';
import { AvailableIcon } from '../../../../../../../types';

export const unknownIcons = (): AvailableIcon[] => [
  {
    iconName: '',
    component: <IconMissing />,
  },
];
